import { required } from '@vuelidate/validators'

export const CreateCityValidation = {
    name: { required },
    typeId: { required },
    regionId: { required },
}

export const CreateRegionValidation = {
    name: { required },
    countryId: { required },
}
